import md5 from 'md5'
import config from '@/common/appConfig.js'
import {
  getBrand,
  getOsInfo,
  getNetworkType
} from '@/common/utils/device'
import {
  localGet,
  localSet
} from '@/common/storage.js'
import axios from 'axios'
const env = config.env
// sdk上报的地址
var report_sdk_url = env === 'development' ? 'https://devdata.muchcloud.com:8082' : 'https://applogs.yunyihudong.com'
// sdk上报的密钥
var report_sdk_key = env === 'development' ? 'yunyousj@2021' : 'yunyousj@2021'
// sdk是否是本地环境
var report_sdk_is_test = env === 'development' ? true : false
// 服务端时间与客户端时间的差值
var timeDiff = 0
// sdk是否加载好了
var report_sdk_isReady = false
// 定时器自增id
var report_sdk_num = 1
// 定时器集合，用于初始化完成后清除
var report_sdk_timerArr = []
// 应用的包名
var report_sdk_pkg = ''
// 403十次不在重新请求
var report_flag = 0
// 上报所需的数据
var report_sdk_report_data = {

  // 初始化需计算的字段
  lib_version: '1.1.5',
  platform: 'H5',
  platform_code: 0,
  os: 'android',
  os_version: '',
  app_version: '',
  brand: 'other',
  model: '',
  menubar_state: 1,
  screen_width: 0,
  screen_height: 0,
  device_id: '',
  session_id: '', // 会话id
  network: 0,
  newer_state: 0,
  icon_state: 0,
  first_qid: '',
  first_lid: '',
  ip: '',
  city: '',
  province: '',
  country: '',

  // 初始话外部传入的字段
  this_qid: '',
  this_lid: '',
  login_state: 0,
  pay_state: 0,
  mode_state: '',
  open_id: '',
  source_pkg: '',
  utm_ad_id: '', // 活动/广告id
  utm_campaign: '', // 活动/广告名称
  utm_content: '', // 活动/广告内容
  utm_medium: '', // 活动/广告媒介
  utm_source: '', // 活动/广告来源
  utm_term: '', // 活动/广告关键字

  // 外部埋点传入的字段
  event_id: '',
  event_name: '',
  scene: '',
  time_stamp: '',
  time_stamp_millis: '',
  ad_style: '',
  ad_type: '',
  page_url: '',
  ad_id: '',
  ad_network: 0,
  result: '',
  ad_position: '',
  referer: '',
  page_type: '',
  page_name: '',
  element_name: '',
  item_ids: [],
  duration: 0,
  pay_amount: 0, // 支付金额

  // 扩展字段
  ext_field_1: '',
  ext_field_2: '',
  ext_field_3: '',
  ext_field_4: '',
  ext_field_5: '',
  ext_field_6: '',
  ext_field_7: '-1',
  ext_field_8: '',
  ext_field_9: '',
  ext_field_10: '',
}

// 记录页面信息
var report_page_show_info = null

// request请求封装promise
function requestPromise(obj = {}) {
  let options = {}
  options.url = obj.url || ''
  options.method = obj.method || 'GET'
  options.headers = obj.headers || {}
  options.data = obj.data || {}
  return new Promise((resolve, reject) => {
    axios({
      ...options
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

// 基础信息初始化
async function sdk_init(obj) {
  report_sdk_isReady = false
  // 同步外部传入参数
  report_sdk_report_data.utm_ad_id = obj && obj.utm_ad_id ? obj.utm_ad_id : ''
  report_sdk_report_data.source_pkg = obj && obj.source_pkg ? obj.source_pkg : ''
  report_sdk_report_data.utm_campaign = obj && obj.utm_campaign ? obj.utm_campaign : ''
  report_sdk_report_data.utm_content = obj && obj.utm_content ? obj.utm_content : ''
  report_sdk_report_data.utm_medium = obj && obj.utm_medium ? obj.utm_medium : ''
  report_sdk_report_data.utm_source = obj && obj.utm_source ? obj.utm_source : ''
  report_sdk_report_data.utm_term = obj && obj.utm_term ? obj.utm_term : ''
  report_sdk_report_data.login_state = obj && obj.login_state ? 1 : 0
  report_sdk_report_data.pay_state = obj && obj.pay_state ? 1 : 0
  report_sdk_report_data.mode_state = 2
  report_sdk_report_data.this_qid = obj && obj.qd_id ? obj.qd_id : '-1'
  report_sdk_report_data.this_lid = obj && obj.link_id ? obj.link_id : '-1'
  report_sdk_report_data.device_id = obj && obj.open_id ? obj.open_id : ''
  report_sdk_report_data.newer_state = obj && obj.newer_state ? 1 : 0
  // 获取应用信息

  report_sdk_pkg = config.currentApp.pkgGroup
  // 运行平台
  report_sdk_report_data.platform = 'H5'
  // 运行平台版本
  report_sdk_report_data.platform_code = 0
  // 操作系统
  report_sdk_report_data.os = getOsInfo() || ''
  // 系统版本 TODO
  report_sdk_report_data.os_version = ''
  // 应用版本
  report_sdk_report_data.app_version = config.app_version
  // 设备品牌
  let tempBrand = getBrand() || 'other'
  report_sdk_report_data.brand = tempBrand
  // 设备型号 TODO
  report_sdk_report_data.model = ''
  // 屏幕宽度
  report_sdk_report_data.screen_width = document.body.clientWidth || 0
  // 屏幕高度
  report_sdk_report_data.screen_height = document.body.clientHeight || 0
  // 设备ID
  try {
    let deviceId = localGet('reportsdk_deviceid')
    if (deviceId) {
      report_sdk_report_data.open_id = deviceId
    } else {
      report_sdk_report_data.open_id = 'SZ00' + Date.now() + parseInt(Math.random() * 899999999999 + 100000000000)
      localSet({
        name: 'reportsdk_deviceid',
        value: report_sdk_report_data.open_id
      })
    }
  } catch (err) {
    report_sdk_report_data.open_id = 'SZ00' + Date.now() + parseInt(Math.random() * 899999999999 + 100000000000)
    localSet({
      name: 'reportsdk_deviceid',
      value: report_sdk_report_data.open_id
    })
  }
  // 会话ID
  report_sdk_report_data.session_id = md5(report_sdk_report_data.open_id) + Date.now()
  // 获取网络状态
  let networkType = getNetworkType()
  switch (networkType) {
    case '2g':
      report_sdk_report_data.network = 3
      break
    case '3g':
      report_sdk_report_data.network = 4
      break
    case '4g':
      report_sdk_report_data.network = 5
      break
    case 'wifi':
      report_sdk_report_data.network = 2
      break
    case 'none':
      report_sdk_report_data.network = 1
      break
    case '5g':
      report_sdk_report_data.network = 6
      break
    default:
      report_sdk_report_data.network = 0
      break
  }
  // 判断新老用户
  // try {
  //   let isNewUser = localGet('reportsdk_isNewUser')
  //   if (isNewUser) {
  //     report_sdk_report_data.newer_state = 1
  //     localSet({name: 'reportsdk_isNewUser',value: '1'})
  //   }
  // } catch (err) { }
  // 获取缓存中的渠道信息
  let today = new Date().getFullYear() + '/' + new Date().getMonth() + '/' + new Date().getDate()
  try {
    let storageQudao = localGet('reportsdk_qudao')
    if (storageQudao) {
      if (storageQudao.date == today) {
        report_sdk_report_data.first_qid = storageQudao.first_qid
        report_sdk_report_data.first_lid = storageQudao.first_lid
      } else {
        report_sdk_report_data.first_qid = report_sdk_report_data.this_qid
        report_sdk_report_data.first_lid = report_sdk_report_data.this_lid
        localSet({
          name: 'reportsdk_qudao',
          value: {
            date: today,
            first_qid: report_sdk_report_data.this_qid,
            first_lid: report_sdk_report_data.this_lid
          }
        })
      }
    } else {
      report_sdk_report_data.first_qid = report_sdk_report_data.this_qid
      report_sdk_report_data.first_lid = report_sdk_report_data.this_lid
      localSet({
        name: 'reportsdk_qudao',
        value: {
          date: today,
          first_qid: report_sdk_report_data.this_qid,
          first_lid: report_sdk_report_data.this_lid
        }
      })
    }
  } catch (err) {
    report_sdk_report_data.first_qid = report_sdk_report_data.this_qid
    report_sdk_report_data.first_lid = report_sdk_report_data.this_lid
    localSet({
      name: 'reportsdk_qudao',
      value: {
        date: today,
        first_qid: report_sdk_report_data.this_qid,
        first_lid: report_sdk_report_data.this_lid
      }
    })
  }
  // 从缓存中获取服务端与客户端的时间差
  try {
    let storageTimeDiff = localGet('reportsdk_time_diff')
    if (storageTimeDiff) {
      timeDiff = Number(storageTimeDiff)
    }
  } catch (err) {}
  // 接口请求ip和省市区
  if (obj && obj.ip && obj.country && obj.province && obj.city) {
    report_sdk_report_data.ip = obj.ip
    report_sdk_report_data.country = obj.country
    report_sdk_report_data.province = obj.province
    report_sdk_report_data.city = obj.city
  } else {
    try {
      let xts = Math.round(new Date() / 1000) + timeDiff
      let result = await requestPromise({
        url: 'https://ip.yunyousj.com:330',
        method: 'GET',
        headers: {
          'Xts': xts,
          'Xsign': md5('/yunyousj@2021' + xts)
        },
        data: {}
      })
      if (result.data) {
        report_sdk_report_data.ip = result.data.ip ? result.data.ip : ''
        report_sdk_report_data.country = result.data.country ? result.data.country : ''
        report_sdk_report_data.province = result.data.region ? result.data.region : ''
        report_sdk_report_data.city = result.data.city ? result.data.city : ''
      }
    } catch (e) {}
  }
  console.log('初始化完成', report_sdk_report_data)
  report_sdk_isReady = true
}

// 上报事件
async function report(obj) {
  try {
    // 验证传入的参数是否正确
    if (typeof obj !== 'object') {
      console.error('SDK传入的参数不正确，必须是对象')
      return false
    }
    if (!obj.event_id) {
      console.error('SDK传入的参数event_id为必传')
      return false
    }
    if (!obj.event_name) {
      console.error('SDK传入的参数event_name为必传')
      return false
    }
    if (obj.result && obj.result.includes('interrupted')) {
      console.error('小程序切后台上报中断')
      return false
    }
    //这个网站含有未知错误。网页可能暂时无法连接，或者它已永久性地移动到了新网址。
    if (obj.result && obj.result.includes('ERR_CONNECTION_RESET')) {
      console.error('小程序切后台上报中断')
      return false
    }
    // 获取当前的时间戳，精确到豪秒
    let xtsMill = Date.now() + timeDiff * 1000
    // 计算当前的时间戳，精确到秒
    let xts = Math.floor(xtsMill / 1000)
    // 如果上报sdk还没初始化完毕，每隔1秒检测一次，初始化完成后再上报
    if (!report_sdk_isReady) {
      await new Promise((resolve, reject) => {
        report_sdk_num++
        let time = JSON.parse(JSON.stringify(report_sdk_num))
        let timer = setInterval(() => {
          try {
            if (report_sdk_isReady) {
              resolve(true)
              report_sdk_timerArr.forEach(element => {
                if (element.time == time) {
                  element.timer && clearInterval(element.timer)
                }
              })
            }
          } catch (ee) {
            console.error('----------------上报SDK等待出错', ee)
            resolve(true)
          }
        }, 1000)
        report_sdk_timerArr.push({
          timer: timer,
          time: time
        })
      })
    }
    let dataObj = JSON.parse(JSON.stringify(report_sdk_report_data))
    dataObj.time_stamp = xts
    dataObj.time_stamp_millis = xtsMill
    let dataObjVal = Object.assign(dataObj, obj)
    let canPostData = true
    if (report_sdk_is_test) {
      // console.log('report_sdk_pkg ========>', report_sdk_pkg)
      try {
        let checkResultJson = await requestPromise({
          // url: 'https://data.muchcloud.com/analysis/extranet/validate',
          url: 'https://devdata.muchcloud.com:8080/analysis/extranet/validate',
          data: dataObjVal,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'App-Origin': report_sdk_pkg
          }
        })
        if (checkResultJson.data.code == -1 && dataObj.platform !== 'devtools') {
          alert(JSON.stringify(checkResultJson.data.data))
          canPostData = false
        }
      } catch (e) {
        console.log('----------------数据校验出错', e)
        canPostData = false
      }
    }
    // try {
    //   dataObjVal.pay_amount = parseFloat((dataObjVal.pay_amount).toFixed(2))
    // } catch (e) {
    //   console.log('----------------转化金额出错', e)
    // }
    if (canPostData) {
      requestPromise({
        url: report_sdk_url + '/' + report_sdk_pkg,
        data: dataObjVal,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Xts': xts,
          'Xsign': md5('/' + report_sdk_pkg + report_sdk_key + xts),
        }
      }).then(async res => {
        if (res.status != 200) {
          console.error('----------------上报接口状态码出错', res, res.status)
        }
        if (res.status == 403 && report_flag < 10) {
          report_flag += 1
          try {
            if (res.data.STATUS == 2000) {
              let timeDiff = res.data.DATA.Time - Math.round(new Date() / 1000)
              localSet({
                name: 'reportsdk_time_diff',
                value: timeDiff
              })
              report(obj)
            }
          } catch (e) {
            console.error('----------------本地时间校验出错', e)
          }
        }
      }).catch(error => {
        console.error('----------------上报SDK返回逻辑执行出错', error)
      })
    }
  } catch (err) {
    console.error('----------------上报SDK执行出错', err)
  }
}

// 设置应用内特有属性
function set_attr(key, value) {
  if (report_sdk_report_data.hasOwnProperty(key)) {
    report_sdk_report_data[key] = value
  }
}

// 上报页面展示，记录时间
function page_show() {
  // 判断是否漏上报
  if (report_page_show_info && report_sdk_is_test) {
    alert('上一个周期的onHide事件未埋点')
  } else {
    // 记录当前页面信息
    let pageTime = Date.now()
    let pageUrl = ''
    try {
      let nowRouter = getCurrentPages()
      pageUrl = nowRouter[nowRouter.length - 1] && nowRouter[nowRouter.length - 1].route || '未知'
    } catch (t) {
      pageUrl = '未知'
    }
    report_page_show_info = {
      page_time: pageTime,
      page_url: pageUrl
    }
  }
}

// 上报页面隐藏，计算时间间隔并上报
async function page_hide() {
  // 判断是否漏上报
  if (!report_page_show_info) {
    if (report_sdk_is_test) {
      alert('上一个周期的onShow事件未埋点')
    }
    return
  }
  // 获取当前的时间戳，精确到豪秒
  let dateNow = Date.now()
  // 计算所需的时间
  let xtsMill = dateNow + timeDiff * 1000
  let xts = Math.floor(xtsMill / 1000)
  let duration = dateNow - report_page_show_info.page_time
  let page_url = report_page_show_info.page_url
  report_page_show_info = null
  // 如果上报sdk还没初始化完毕，每隔1秒检测一次，初始化完成后再上报
  if (!report_sdk_isReady) {
    await new Promise((resolve, reject) => {
      report_sdk_num++
      let time = JSON.parse(JSON.stringify(report_sdk_num))
      let timer = setInterval(() => {
        try {
          if (report_sdk_isReady) {
            resolve(true)
            report_sdk_timerArr.forEach(element => {
              if (element.time == time) {
                element.timer && clearInterval(element.timer)
              }
            })
          }
        } catch (ee) {
          console.error('----------------上报SDK等待出错', ee)
          resolve(true)
        }
      }, 1000)
      report_sdk_timerArr.push({
        timer: timer,
        time: time
      })
    })
  }
  // 组合需要上报的数据
  let dataObj = JSON.parse(JSON.stringify(report_sdk_report_data))
  let obj = {
    event_id: 'used_duration',
    event_name: '用户使用时长',
    time_stamp: xts,
    time_stamp_millis: xtsMill,
    duration: duration,
    page_url: page_url,
  }
  let dataObjVal = Object.assign(dataObj, obj)
  // 上报页面访问时长
  requestPromise({
    url: report_sdk_url + '/' + report_sdk_pkg,
    data: dataObjVal,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Xts': xts,
      'Xsign': md5('/' + report_sdk_pkg + report_sdk_key + xts),
    }
  }).then(async res => {
    if (res.status != 200) {
      console.error('----------------上报接口状态码出错', res.status)
    }
    if (res.status == 403 && report_flag < 10) {
      report_flag += 1
      try {
        if (res.data.STATUS == 2000) {
          let timeDiff = res.data.DATA.Time - Math.round(new Date() / 1000)
          localSet({
            name: 'reportsdk_time_diff',
            value: timeDiff
          })
          report(obj)
        }
      } catch (e) {
        console.error('----------------本地时间校验出错', e)
      }
    }
  }).catch(error => {
    console.error('----------------上报SDK返回逻辑执行出错', error)
  })
}

function export_data() {
  return report_sdk_report_data
}

let report_sdk = {
  sdk_init: sdk_init,
  report: report,
  set_attr: set_attr,
  page_show: page_show,
  page_hide: page_hide,
  export_data: export_data
}
global.REPORT_SDK = report_sdk
export default report_sdk
